import dayjs from "dayjs";

export default function timeAgo(dateString: string): string {
  const date = dayjs(dateString);
  const now = dayjs();
  const diffInSeconds = now.diff(date, "second");
  const diffInMinutes = now.diff(date, "minute");
  const diffInHours = now.diff(date, "hour");
  const diffInDays = now.diff(date, "day");

  if (diffInDays > 0) {
    return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
  }
  if (diffInHours > 0) {
    return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
  }
  if (diffInMinutes > 0) {
    return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
  }
  if (diffInSeconds > 0) {
    return `${diffInSeconds} second${diffInSeconds > 1 ? "s" : ""} ago`;
  }
  return "just now";
}
